import React from 'react'
import _ from 'lodash'
import format from 'format-number'
import { Mailto } from 'libreact/lib/Mailto'
import totalCostsSum from '../../../../../../calculations/totalCosts/sum'
import averageMonthlyCostByAge from '../../../../../../calculations/averageMonthlyCostByAge'
import annualCostsByAge from '../../../../../../calculations/annualCostsByAge'
import { ReactComponent as EmailIcon } from '../../../../../../assets/email.svg'
import Button from './Button'

const formatter = format({ prefix: '$', round: 0 })

const subject = 'I just found out my personal costs for raising a child'
const body = ({ form, url }) => `Hey there,

I just filled out the Child Affordability Calculator and found out that my personal total cost for raising a child is ${formatter(totalCostsSum(form))}, average monthly cost is ${formatter(_.meanBy(averageMonthlyCostByAge(form), 'value'))} and the average yearly cost is ${formatter(_.meanBy(annualCostsByAge(form), 'value'))}.

Check it out for yourself at ${url}
`

export default (props) => (
  <Mailto email='' subject={subject} body={body(props)}>
    <Button icon={EmailIcon} />
  </Mailto>
)
